import SVGFromURL from "@/app/_components/SVGFromURL";
import { sendDownloadEvent } from "@/app/_ga4/eventHandler";
import Link from "next/link";
import React from "react";

export default function Manuals(props) {
  const manuals = props.data;
  return (
    <div className="manuals-wrapper">
      {manuals.map((manual) => (
        <Link
          href={manual.url}
          key={manual.id}
          target="_blank"
          onClick={() =>
            sendDownloadEvent(
              manual.manual_type.data.attributes.name,
              manual.manual_type.data.attributes.name
            )
          }
        >
          <div className="manual">
            <div className="manual-image">
              <SVGFromURL
                url={
                  manual.manual_type.data.attributes.image.data.attributes.url
                }
              />
            </div>
            <div className="manual-title">
              {manual.manual_type.data.attributes.name}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
